import Modules from '../../../components/vehicle/modules'
import ModulesStore from '../../../components/vehicle/modules/context/context'

const ModulesPage = () => {
  return (
    <ModulesStore>
      <Modules />
    </ModulesStore>
  )
}

export default ModulesPage
